import { render } from "./PageEspecialidade.vue?vue&type=template&id=3fa11856&scoped=true"
import script from "./PageEspecialidade.vue?vue&type=script&lang=js"
export * from "./PageEspecialidade.vue?vue&type=script&lang=js"

import "./PageEspecialidade.vue?vue&type=style&index=0&id=3fa11856&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa11856"]])

export default __exports__